<template>
  <div class="login">
    <div class="login__header">
      <img src="media/logos/logo.png" alt />
      <h1 class="login__header--title">Visor DB Mercantil</h1>
      <div class="login__header--sub-title">Login</div>
    </div>
    <b-form @submit.stop.prevent="onSubmit" class="login__form">
      <div role="alert" v-bind:class="{ show: errors.length }">
        <div class="alert-text" v-for="(error, i) in errors" :key="i">
          {{ error }}
        </div>
      </div>

      <!-- email -->
      <b-form-group
        id="example-input-group-1"
        label
        label-for="example-input-1"
      >
        <b-form-input
          id="example-input-1"
          name="example-input-1"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          aria-describedby="input-1-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-1-live-feedback"
          >El email es requerido y debe ser válido.</b-form-invalid-feedback
        >
      </b-form-group>

      <!-- password -->
      <b-form-group
        id="example-input-group-2"
        label
        label-for="example-input-2"
      >
        <b-form-input
          type="password"
          id="example-input-2"
          name="example-input-2"
          v-model="$v.form.password.$model"
          :state="validateState('password')"
          aria-describedby="input-2-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-2-live-feedback"
          >La contraseña es requerida.</b-form-invalid-feedback
        >
      </b-form-group>

      <!-- Actions -->
      <div class="login__form--actions">
        <button
          ref="kt_login_signin_submit"
          class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
        >
          Entrar
        </button>
      </div>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/pages/login/login.scss";
</style>

<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

import { BToast } from "bootstrap-vue";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { username: email, password: password })
          // go to which page after successfully login
          .then(() => {
            new BToast().$bvToast.toast("Has entrado correctamente al sistema", {
              title: "Login",
              variant: "success",
              solid: true
            });
            this.$router.push("/");
          })
          .catch(e => {
            if (new String(e).includes("401")) {
              new BToast().$bvToast.toast("Usuario o contraseña incorrecta", {
                title: "Error",
                variant: "danger",
                solid: true
              });
            }
          });
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 2000);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
